export default "/images/db62d561aa17cc7d0b467079038de07f.avif";